import { useFormatShortDate as formatShortDate, useFormatTime as formatTime, } from '@coolblue-development/next-formatting-utils/client';
import { isTomorrow } from 'date-fns';
import { TODAYS_OPEN_STATUS } from '../../enums/index.js';
import { getStoreTimes } from '../getStoreTimes/getStoreTimes.js';
export const getInStockAvailability = ({ schedules, storeDates, timeTravelOverride, t, }) => {
    const { today, todaysOpenStatus, nextOpenDay } = getStoreTimes({
        storeDates,
        schedules,
        timeTravelOverride,
    });
    const formatPickupInfo = (date) => ({
        pickupDay: date ? formatShortDate(date) : '',
        pickupTime: date ? formatTime(date) : '',
    });
    // If store is open now, return direct pickup message
    if (todaysOpenStatus === TODAYS_OPEN_STATUS.OPEN_NOW && today) {
        return {
            promise: t('onStock'),
            description: t('directPickup'),
        };
    }
    // Case: Pickup today - Store opens later today
    if (todaysOpenStatus === TODAYS_OPEN_STATUS.OPENING_LATER && (today === null || today === void 0 ? void 0 : today.pickupTime)) {
        const pickupTime = formatTime(today.pickupTime);
        return {
            promise: t('onStock'),
            description: t('storePickupToday', { pickupTime }),
        };
    }
    // Case: Next open day is tomorrow
    if ((nextOpenDay === null || nextOpenDay === void 0 ? void 0 : nextOpenDay.date) && isTomorrow(nextOpenDay.date)) {
        const nextPickupDate = formatTime(nextOpenDay.pickupTime);
        return {
            promise: t('onStock'),
            description: t('nextDayPickup', { nextPickupDate }),
        };
    }
    // Case: Next open day is not tomorrow
    // TODO: Understand why we are checking for nextOpenDay existence here, could be checked before in the flow
    const { pickupDay, pickupTime } = (nextOpenDay === null || nextOpenDay === void 0 ? void 0 : nextOpenDay.pickupTime)
        ? formatPickupInfo(nextOpenDay === null || nextOpenDay === void 0 ? void 0 : nextOpenDay.pickupTime)
        : { pickupDay: '', pickupTime: '' };
    return {
        promise: t('onStock'),
        description: t('storePickupAtDay', { pickupDay, pickupTime }),
    };
};
//# sourceMappingURL=getInStockAvailability.js.map